/*
 * Description: 与SDK通信接口
 * Date: 2019-09-19 10:35:31
 * Author: yaoshun
 * LastEditTime: 2019-09-19 17:45:24
 */
import jsBridge from '../common/jsBridge'
import {_device} from "../common/m_base/util";
import App from '../class/App'

/**
 * componentReact 监听器
 */
export {
    onComponentReactCloseButtonTriggered,
    onComponentReactDeveloperCallbackSHOWSUCCESS,
    onComponentReactPreloadURLFinished
} from "./componentReactListener";

/**
 * @api {get} customCommand 自定义命令, 仅用于大模板 demo 页 SDK API 调试, 请不要在生产环境模板中使用
 * @apiName 自定义命令
 * @apiGroup 杂项
 * @apiParam fnName SDK API 指令 path
 * @apiParam params 调用时的入参
 * @return {*|Promise<any>} 返回调用 SDK API 成功时的数据
 */
export function customCommand({fnName, params}) {
    return jsBridge.callNative({fnName, params})
}

/**
 * RewardJs/getEndScreenInfo
 * @param params
 * @returns {*|Promise<any>}
 */
export function RewardJsGetEndScreenInfo(params = {pageNo: 1, exclude_ids: []}) {
    return jsBridge.callNative({fnName: 'RewardJs/getEndScreenInfo', params})
}

// rewardjs 安装调用install（ec）,后续考虑播放模版和ec能否公用一个
export function RewardJsInstall(params) {
    return jsBridge.callNative({fnName: 'RewardJs/install', params})
}
// rv/iv 安装调用click
export function VideoBridgeClick(params) {
    return jsBridge.callNative({fnName: 'VideoBridge/click', params})
}

// 从 SDK 获取上下文环境数据
export function VideoBridgeInit(params = {pageNo: 1, exclude_ids: [],h5cbp:1}) {
    return jsBridge.callNative({fnName: 'VideoBridge/init', params})
}


/**
 * 显示并设置原生视频位置
 * @param params
 * @returns {*|Promise<any>}
 */
export function VideoBridgeShowVideoLocation(params = {}) {
    return jsBridge.callNative({fnName: 'VideoBridge/showVideoLocation', params})
}

/**
 * 播放视频
 * @returns {*|Promise<any>}
 */
export function VideoBridgeVideoOperatePlay() {
    return jsBridge.callNative({fnName: 'VideoBridge/VideoOperate', params: {"pause_or_resume": 1}})
}

/**
 * 暂停播放视频
 * @returns {*|Promise<any>}
 */
export function VideoBridgeVideoOperatePause() {
    return jsBridge.callNative({fnName: 'VideoBridge/VideoOperate', params: {"pause_or_resume": 2}})
}

// load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
export function VideoBridgeReadyStatusHasReady(params = {isReady: 1}) {
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params})
}

// load 阶段通知 SDK "H5 页面没有 ready"
export function VideoBridgeReadyStatusNotReady({errMessage, errDetail} = {}) {
    localStorage.setItem(new Date().toLocaleString(), JSON.stringify({errMessage, errDetail}))
    let params = Object.assign({errMessage, errDetail}, {isReady: 2})
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params})
}

// iOS 下禁用页面滑动反弹
export function VideoBridgeToggleBouncesOff(params = {state: 0}) {
    if (_device().isiOS) {
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

// iOS 下启用页面滑动反弹
export function VideoBridgeToggleBouncesOn(params = {state: 1}) {
    if (_device().isiOS) {
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

/**
 * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
 * @param {String} unitid 广告位 id
 * @param {Number} type //资源的类型（1:视频，2:web素材地址）
 * @param {String} ref //下发的文件远程地址 或者其他可以唯一标示本地资源的索引
 * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
 */
export function VideoBridgeGetZipFileInfo({unitid, type = 2, ref}) {
    let params = {
        unitid,
        resource: [{ref, type}]
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getFileInfo', params})
}

/**
 * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
 * @param {String} unitid 广告位 id
 * @param {Number} type //资源的类型（1:视频，2:web素材地址）
 * @param {String} ref //下发的文件远程地址 或者其他可以唯一标示本地资源的索引
 * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
 */
export function VideoBridgeGetVideoFileInfo({unitid, type = 1, ref}) {
    let params = {
        unitid,
        resource: [{ref, type}]
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getFileInfo', params})
}
/**
 * 回调协议，hit=1 扣回调，否则回调
 * @param {String} unitid   广告位 id
 * @param {Number} type  回调的类型
 *   1:showSuccess，
 *   2:showfailed (error)，
 *   3:playCompleted，
 *   4:endcardShowSuccess，
 *   5:clicked，
 *   6:dismissed（Number convert）
 * @param {Number} hit  1：扣回调，其他不扣
 * @param {Boolean} expired  true,超时，false,不超时
 * @param {Object} campaign  仅在type=6时，传campaign
 * @param {Object} reward,关闭时机，convert=1时传入
 * @param {String} convert，关闭时机，奖励回调是传入1，否则传入2
 * @returns {*|Promise<any>}
 */
export function VideoBridgeReactDeveloper({unitId, type, hit,expired,campaign={},reward={},convert="",error={}}) {
    // type为6时，需要campaign,convert，convert:1则需要传入reward,convert为2，reward可传可不传，type为2，传入error对象，其他type值data里的都不传
    let params = {}
    if(type === 6){
        params = {
            unitId,
            type,
            hit,
            data: {
                campaign,
                reward,
                convert,
                expired,
            }
        }
    }else if(type === 2){
        params = {
            unitId,
            type,
            hit,
            data: {
                error,
                expired,
            }
        }
    }else{
        params = {
            unitId,
            type,
            hit,
            data: {
                expired,
            }
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/reactDeveloper', params})
}

/**
 * 自动load协议
 * @param {String} unitId 广告位 id
 * @param {String} placementId 板块id
 * @param {String} adtype 1：rv,2:iv
 * @returns {*|Promise<any>}
 */
export function VideoBridgeLoadAds({unitId, placementId, adtype}) {
    // type  默认为1，自动load
    let params = {
        unitId,
        placementId,
        adtype,
        type: 1
    }
    return jsBridge.callNative({fnName: 'VideoBridge/loadads', params})
}

export function createWebview(params = {"action": 1, "data": {"type": 1, "unitid": "21309"}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function createPlayerView(params = {"action": 1, "data": {"type": 2, "unitid": "21309"}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function createStoreKit(params = {"action": 1, "data": {"type": 3, "unitid": "21309"}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

/**
 * 创建一个 "type 4 类型" 组件
 * @param campaign
 * @param unitid
 * @param unitsetting
 * @returns {*|Promise<any>}
 */
export function createVideoTemplateLegacy({campaign, unitid, unitsetting}) {
    let params = {
        action: 1,
        data: {
            type: 4,
            unitid,
            data: {
                campaign,
                unitid,
                unitsetting,
            },
        }
    }
    let callNativeResponse = jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params});
    console.log('createVideoTemplateLegacy: ', {params, callNativeResponse})
    return callNativeResponse
}

export function preloadVideoTemplateLegacy({cmpt}) {
    let params = {
        action: 401,
        cmpt,
        data: {}
    }
    console.log('preloadVideoTemplateLegacy: ', params)
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function addVideoTemplateLegacy({parentCmpt, childCmpt}) {
    let params = {
        action: 11,
        cmpt: parentCmpt, // 父视图
        data: {
            cmpt: childCmpt, // 子视图
            rect:  {top: 10, bottom: 20, left: 20, right: 30} // width 或 height 不传, 则为父视图宽高
        }
    }
    console.log('addVideoTemplateLegacy: ', params)
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function showVideoTemplateLegacy(params = {"action": 7, "data": {"type": 4, "unitid": "21309", "hidden": 0}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function hideVideoTemplateLegacy(params = {"action": 7, "data": {"type": 4, "unitid": "21309", "hidden": 1}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function closeVideoTemplateLegacy({unitid, cmpt}) {
    let params = {
        action: 402,
        cmpt,
        data: {
            type: 4,
            unitid
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function createEndCardLegacy(params = {"action": 1, "data": {"type": 5, "unitid": "21309"}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function showEndCardLegacy(params = {"action": 7, "data": {"type": 5, "unitid": "21309", "hidden": 0}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

export function hideEndCardLegacy(params = {"action": 7, "data": {"type": 5, "unitid": "21309", "hidden": 1}}) {
    return jsBridge.callNative({fnName: 'VideoBridge/operateComponent', params})
}

//------------------------------ 原生事件监听 ------------------------------//
/**
 * 暂停页面，切换出`app`
 * @param cb
 */
export function onSystemPause(cb) {
    jsBridge.addEventListener('onSystemPause', function (res) {
        console.log('onSystemPause res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 唤醒`app`
 * @param cb
 */
export function onSystemResume(cb) {
    jsBridge.addEventListener('onSystemResume', function (res) {
        console.log('onSystemResume res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 查询是否在前台,0是在前台，1为不在前台
 * @param cb
 */
export function isSystemResume(cb) {
    jsBridge.addEventListener('isSystemResume', function (res) {
        console.log('isSystemResume res: ', res)
        cb(res)
    }, false)
}

/**
 * 销毁当前页面 不能有回调
 * @param cb
 */
export function onSystemDestory(cb) {
    jsBridge.addEventListener('onSystemDestory', function (res) {
        console.log('onSystemDestory res: ', res.param)
        cb(res.param)
    }, false)
}

/**
 * 视频状态通知监听
 * @param cb
 */
export function onVideoStatusNotify(cb) {
    jsBridge.addEventListener('onVideoStatusNotify', function (res) {
        cb(res.param)
    }, false)
}

/**
 * `sdk`通知`js`点击事件
 * @param cb
 */
export function onJSClick(cb) {
    jsBridge.addEventListener('onJSClick', function (res) {
        console.log('onJSClick res: ', res.param)
        cb(res.param)
    }, false)
}

/**
 * 监听横竖屏旋转
 * @param cb
 * portrait 竖屏，landscape 横屏
 */
export function orientation(cb) {
    jsBridge.addEventListener('orientation', function (res) {
        console.log('orientation res: ', res.param)
        cb(res)
    }, false)
}

/**
 * webviewshow，与onAdShow 相同
 * @param cb
 */
export function onWebviewshow(cb) {
    jsBridge.addEventListener('webviewshow', function (res) {
        console.log('webviewshow res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 监听安卓的`回退`按钮
 * @param cb
 */
export function onSystemBackPressed(cb) {
    jsBridge.addEventListener('onSystemBackPressed', function (res) {
        cb && cb(res.param)
    }, false)
}

/**
 * onJSBridgeConnect
 * @param cb
 */
export function onJSBridgeConnected(cb) {
    jsBridge.addEventListener('onJSBridgeConnected', function (res) {
        cb(res)
    }, false)
}

/**
 * ios 展示 storekit 成功或者失败
 * @param cb
 */
export function storeKitShowSuccess(cb) {
    jsBridge.addEventListener('storeKitShowSuccess', function (res) {
        cb(res.param)
    }, false)
}

/**
 * 播放进度通知状态,progress表示当前进度如0.20,time表示当前播放时长单位秒,duration表示总时长
 * @param cb
 */
export function onVideoProgressNotify(cb) {
    jsBridge.addEventListener('onVideoProgressNotify', function (res) {
        cb(res.param)
    }, false)
}

/**
 * IOS 主动通知 屏幕宽高和方向
 * @param cb
 */
export function showDataInfo(cb) {
    jsBridge.addEventListener('showDataInfo', function (res) {
        cb(res.param)
    }, false)
}


//****************************************************************************************************************//

/**
 * 广播
 * @param eventName
 * @param data
 * @returns {Promise<any>}
 */
export function broadcast(eventName, data) {
    const unitId = App && App.unit && App.unit.id || App && App.initData && App.initData.unit_id
    console.log('发送广播', eventName, data)
    return jsBridge.callNative({fnName: 'VideoBridge/broadcast', params:{unitId, eventName, data}})
}

/**
 * 监听广播
 * @param bindEventName
 * @param cb
 */
export function onBroadcast(bindEventName, cb) {
    jsBridge.addEventListener('broadcast', function (event) {
        // console.log('监听到广播!!!!', event, event.param.eventName,  bindEventName, event.param.data && event.param.data.eventName)
        const { eventName, data } = event.param
        if(eventName === bindEventName){
            cb(event.param)
        }
    }, false)
}
/*
jsBridge.addEventListener('broadcast', function (event) {
    console.log('监听到广播!!!!', location.href, event, event.param.eventName, event.param.data && event.param.data.eventName)
    const ifms = document.querySelectorAll('iframe.mtg-tpl')
    console.log('ifms.length ==================>', ifms.length, location.href)
    ifms.forEach(ifm=>{
        // const ifmWindow = ifm.contentWindow
        const ifmDocument = ifm.contentDocument
        var ev = ifmDocument.createEvent('HTMLEvents')
        ev.initEvent('broadcast', false, true)
        ev.param = event.param
        ifmDocument.dispatchEvent(ev)
        ev=null
        console.log('数据发送到 ==================>', ifm, location.href, ifmDocument===document)
    })
}, false)

jsBridge.addEventListener('broadcast222', function (event) {
    console.log('监听到广播222!!!!', location.href, event, event.param.eventName, event.param.data && event.param.data.eventName)
}, false)
*/


// 从 SDK 获取上下文环境数据
export function fetchInitData(params = {pageNo: 1, exclude_ids: []}) {
    return jsBridge.callNative({fnName: 'VideoBridge/init', params})
}


// load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
export function readyToShowAD() {
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params:{isReady: 1}})
}

// load 阶段通知 SDK "H5 页面没有 ready"
export function failureToShowAD({errMessage, errDetail} = {}) {
    localStorage.setItem(new Date().toLocaleString(), JSON.stringify({errMessage, errDetail}))
    let params = Object.assign({errMessage, errDetail}, {isReady: 2})
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params})
}

export function onAdShow(cb) {
    jsBridge.addEventListener('webviewshow', function (res) {
        console.log('webviewshow res: ', res.param)
        cb(res)
    }, false)
}

//由于banner需求sdk端无法给开发者webviewshow回调的bug，临时由h5自己发送dowebviewshow事件来模拟之前sdk发送的webviewshow事件
//该方法在新的sdk版本中不会使用
export function onAdShowTemp(cb) {
    jsBridge.addEventListener('dowebviewshow', function (res) {
        console.log('dowebviewshow res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
 * @param {String} unitId - 广告位 id
 * @param {Object[]} resource - 要获取的资源描述列表
 * @param {Number} resource[].type - 资源的类型（1:视频，2:web素材地址）
 * @param {String} resource[].ref - 下发的文件远程地址 或者其他可以唯一标示本地资源的索引
 * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
 */
export function VideoBridgeGetFileInfo({unitId, resource}) {
    let params = {
        unitId,
        resource,
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getFileInfo', params})
}


export function closeAd(unitId, id) {
    let params = {
        unitId,
        // id,
        data:{},
    }
    console.log('closeAd 关闭广告，unitId:', unitId, params)
    return jsBridge.callNative({fnName: 'VideoBridge/closeAd', params})
}




// 从 SDK 获取上下文环境数据
export function bannerFetchInitData(params = {pageNo: 1, exclude_ids: []}) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/init', params})
}


// load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
export function bannerReadyToShowAD() {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/readyStatus', params:{isReady: 1}})
}

// load 阶段通知 SDK "H5 页面没有 ready"
export function bannerFailureToShowAD({errMessage, errDetail} = {}) {
    localStorage.setItem(new Date().toLocaleString(), JSON.stringify({errMessage, errDetail}))
    let params = Object.assign({errMessage, errDetail}, {isReady: 2})
    return jsBridge.callNative({fnName: 'BannerJSPlugin/readyStatus', params})
}

/**
 * js 通知SDK发送用具体UA上报url
 * @param {Object} params
 * @param {Number} params.type campaign.onlyImpressionUrl,
 * @param {String} params.url campaign.impressionUA
 */
export function reportUrl(params = {type: 1, url: ''}) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/reportUrl', params})
}

/**
 * js通知SDK 在客户端发出请求,iOS SDK从v5.6.0 Banner版本开始支持，所有广告类型都支持
 *  数组元素:  {"url":"www.mintegral.com", "type":2}
 *  要求SDK 以type类型的uaType来请求改url
 * type 为可选，目前Impression 一定有，其他的不一定有
 */
export function reportUrls(params = [{type: 1, url: ''}, {type: 1, url: ''}]) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/reportUrls', params})
}

export function sendImpressions(params = []) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/sendImpressions', params})
}


// 显示 native 关闭按钮
export function showNativeCloseBtn() {
    const params = {state: 1}
    return jsBridge.callNative({fnName: 'BannerJSPlugin/toggleCloseBtn', params})
}

// 隐藏 native 关闭按钮
export function hideNativeCloseBtn() {
    const params = {state: 2}
    return jsBridge.callNative({fnName: 'BannerJSPlugin/toggleCloseBtn', params})
}

//设置 native 关闭按钮显示状态
export function setNativeCloseBtnDisplay(state) {
    const params = {state}
    return jsBridge.callNative({fnName: 'BannerJSPlugin/toggleCloseBtn', params})
}

// banner click
export function bannerClick(params) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/click', params})
}

//	获取网络状态
export function getNetstat(params) {
    return jsBridge.callNative({fnName: 'BannerJSPlugin/getNetstat', params})
}
//	网络状态变更时通知
export function onNetstatChanged(cb) {
    jsBridge.addEventListener('onNetstatChanged', function (res) {
        console.log('onNetstatChanged res: ', res.param)
        cb(res.param)
    }, false)
}

/**
 * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
 * @param {String} unitid 广告位 id
 * @param {Number} type //资源的类型（1:视频，2:web素材地址, 4:img）
 * @param {String} ref //下发的文件远程地址 或者其他可以唯一标示本地资源的索引
 * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
 */
export function getVideoPath({unitId, ref}) {
    let params = {
        unitId,
        resource: [{ref, type: 1}]
    }
    return jsBridge.callNative({fnName: 'BannerJSPlugin/getFileInfo', params})
}

//视图展示时通知
export function onViewAppeared(cb) {
    jsBridge.addEventListener('onViewAppeared', function (res) {
        console.log('onViewAppeared res: ', res.param)
        cb(res.param)
    }, false)
}

//视图隐藏时通知
export function onViewDisappeared(cb) {
    jsBridge.addEventListener('onViewDisappeared', function (res) {
        console.log('onViewDisappeared res: ', res.param)
        cb(res.param)
    }, false)
}

// iOS 下禁用页面滑动反弹
export function toggleBouncesOff() {
    if (_device().isiOS) {
        const params = {state: 0}
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

// iOS 下启用页面滑动反弹
export function toggleBouncesOn() {
    if (_device().isiOS) {
        const params = {state: 1}
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

// offer被展示，操作设备持久化存放offer展示频次表(RV/IV广告类型)
export function increaseOfferFrequenceForRvIv(params) {
    return jsBridge.callNative({fnName: 'VideoBridge/increaseOfferFrequence', params})
}

export function videoBridgeReportUrls(params = [{type: 1, url: ''}, {type: 1, url: ''}]) {
    return jsBridge.callNative({fnName: 'VideoBridge/reportUrls', params})
}